import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { canManageLayers } from '../../lib/tokens';

/** Guards management-only pages (add/edit layer, map settings, dictionary
 * editing) against direct URL navigation — the corresponding backend endpoints
 * already reject these roles, this just avoids a dead-end page reachable by a
 * bookmark or typed URL for Оператор/Наблюдатель. */
export function RequireCanManageLayers({ children }: { children: ReactNode }) {
  if (!canManageLayers()) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
